const FOCO = "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secundario focus-visible:ring-offset-2";

// Toggle Sí/No genérico — dos pastillas con aria-pressed, mismo idioma que
// el grupo de swatches de SelectorColorSemantico.tsx. Primer componente de
// este tipo en el ERP: no existía ningún toggle booleano más allá de un
// <input type="checkbox">.
export function AlternativaBinaria({
  valor,
  onCambiar,
  etiquetaSi = "Sí",
  etiquetaNo = "No",
  disabled,
}: {
  valor: boolean;
  onCambiar: (valor: boolean) => void;
  etiquetaSi?: string;
  etiquetaNo?: string;
  disabled?: boolean;
}) {
  return (
    <div className="inline-flex gap-2" role="group">
      <button
        type="button"
        disabled={disabled}
        aria-pressed={!valor}
        onClick={() => onCambiar(false)}
        className={`rounded-lg border px-3.5 py-1.5 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${FOCO} ${
          !valor ? "border-principal bg-principal text-superficie" : "border-borde bg-superficie text-texto hover:bg-fondo"
        }`}
      >
        {etiquetaNo}
      </button>
      <button
        type="button"
        disabled={disabled}
        aria-pressed={valor}
        onClick={() => onCambiar(true)}
        className={`rounded-lg border px-3.5 py-1.5 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${FOCO} ${
          valor ? "border-principal bg-principal text-superficie" : "border-borde bg-superficie text-texto hover:bg-fondo"
        }`}
      >
        {etiquetaSi}
      </button>
    </div>
  );
}
